export default class SearchUtils {
    static searchAllItemsProperties(list, searchKey, searchableColumns = [], caseSensitive = false) {
        return list.filter((item) => {
            return this.searchItemProperties(item, searchKey, searchableColumns, caseSensitive);
        });
    }
    static searchItemProperties(item, searchKey, searchableColumns, caseSensitive) {
        return Object.keys(item).some((key) => {
            if (searchableColumns.length > 0 && searchableColumns.toLocaleString().toLocaleLowerCase().indexOf(key.toLocaleLowerCase()) > -1) {
                // @ts-ignore
                const value = item[key];
                if (!value) {
                    return false;
                }
                if (caseSensitive) {
                    return value.includes(searchKey);
                }
                return value.toLocaleString().toLocaleLowerCase().includes(searchKey.toLocaleLowerCase());
            }
            else
                return false;
        });
    }
    static searchItemProperty(item, property, search, caseSensitive = false) {
        const value = item[property];
        if (!value) {
            return false;
        }
        if (caseSensitive) {
            return value.toLocaleString().includes(search);
        }
        return value.toLocaleString().toLocaleLowerCase().includes(search.toLocaleLowerCase());
    }
    static searchAllItemsSingleProperty(list, property, search) {
        return list.filter(item => {
            return this.searchItemProperty(item, property, search);
        });
    }
}
